
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('item_category_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button class="btn btn-outline-primary btn-sm no-bor" @click="newHandler">
                <i class="fa fa-plus-circle"></i> {{$t('new')}}
            </button>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="view_type=0" :class="{active:view_type==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="view_type=1" :class="{active:view_type==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card n_card no-bor">
                <div class="card-body" style="padding: 0;">
                    <table class="table table-bordered table-sm no-bor" style="overflow-x: scroll">
                        <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                            <th>{{ $t('code') }}</th>
                            <th>{{ $t('khmer_name') }}</th>
                            <th>{{ $t('latin_name') }}</th>
                            <th>{{ $t('description') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td><a href="javascript:void(0)" @click="editHandler(ret)">{{ret.Code}}</a></td>
                            <td>{{ret.Name}}</td>
                            <td>{{ret.NameEng}}</td>
                            <td>{{ret.Description}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="box-page">
                <b-pagination
                    size = "sm"
                    :total-rows="query.total"
                    :per-page="query.limit"
                    v-model="query.currentPage"
                    :prev-text="$t('pre')"
                    :next-text="$t('next')"
                    hide-goto-end-buttons />
            </div>
        </div>
        <FormModal ref="form" v-on:done="doneHandler" :value="edit" :isUpdate="isedit"/>
    </div>
</template>
<script>
    import FormModal from "./Form.vue";
    export default {
        components: { FormModal },
        data: function() {
            return {
                query: {
                    currentPage: 1,
                    total: 0,
                    limit: 10
                },
                records: [],
                edit: null,
                view_type: 0
            };
        },
        created: function() {
            this.init();
        },
        methods: {
            init: function() {
                var loading = this.$loading.show();
                this.$api().post('category').then(res => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Data;
                    }
                }).finally(function(){ loading.hide(); });
            },
            newHandler: function(){
                this.edit = {
                    Name: '',
                    Description: ''
                };
                this.$refs.form.$refs.innermodal.show();
            },
            editHandler: function(item) {
                this.edit = JSON.parse(JSON.stringify(item));
                this.$refs.form.$refs.innermodal.show();
            },
            doneHandler: function() {
                this.init();
            }
        }
    };
</script>
